export interface VendorPaymentMethodConstructor {
  id: number
  name: string
  currencyId: number // options filtered to the card currency (BHV-045)
}

export class VendorPaymentMethod {
  readonly id: number
  readonly name: string
  readonly currencyId: number

  constructor(data: VendorPaymentMethodConstructor) {
    this.id = data.id
    this.name = data.name
    this.currencyId = data.currencyId
  }

  matchesCurrency(currencyId: number): boolean {
    return this.currencyId === currencyId
  }
}
